export default function(){
    const generateStars = (reviewScore) => {
        let wrapper = document.createElement('div');

        let i = 0;

        let revAvgRemaining = reviewScore - Math.floor(reviewScore);

        for (i; i < Math.floor(reviewScore); i++) {
            let fullStar =  document.querySelector('.star.star-full').cloneNode(true);
            fullStar.classList.remove('d-none');
            wrapper.appendChild(fullStar);
        }
        if (revAvgRemaining) {
            let halfStar =  document.querySelector('.star.star-half').cloneNode(true);
            wrapper.appendChild(halfStar)
            i++;
        }
        for (i; i < 5; i++) {
            let greyStar = document.querySelector('.star.star-grey').cloneNode(true);
            wrapper.appendChild(greyStar)
        }

        return wrapper.innerHTML;
    }

    return {
        generateStars
    }
}
